import React, { useEffect, useRef } from 'react';
import './SmarterAds.css';

function SmarterAds() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // Add animation classes when in view
          entry.target.classList.add('animate-in');
          
          // Trigger specific animations
          if (entry.target.classList.contains('smarter-ads-title')) {
            entry.target.style.animationDelay = '0.2s';
          }
          if (entry.target.classList.contains('smarter-ads-text')) {
            entry.target.style.animationDelay = '0.4s';
          }
          if (entry.target.classList.contains('smarter-ads-image')) {
            entry.target.style.animationDelay = '0.6s';
          }
        }
      });
    }, observerOptions);

    // Observe elements
    const elements = [titleRef.current, textRef.current, imageRef.current];
    elements.forEach(el => el && observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="smarter-ads-section" ref={sectionRef}>
      <div className="smarter-ads-container">
        <div className="smarter-ads-content">
          <h2 className="smarter-ads-title" ref={titleRef}>
            <span className="text-reveal">Smarter Ads.</span>
            <span className="highlight text-reveal">Bigger Impact</span>
          </h2>
          <p className="smarter-ads-text" ref={textRef}>
            We help businesses grow online with complete digital marketing solutions using tools like Google Ads, 
            Google Analytics, Google Tag Manager, Google Search Console, and Google My Business. We create targeted 
            ad campaigns to drive traffic, track performance with detailed analytics, manage tags easily for better 
            tracking, improve search rankings, and boost your local presence. Our goal is to deliver more visibility, 
            more leads, and better results for your business through smart, data-driven strategies.
          </p>
        </div>
        <div className="smarter-ads-image" ref={imageRef}>
          <div className="image-wrapper">
            <img 
              src={require('../assets/ads.png')} 
              alt="Digital Marketing Solutions" 
              className="animated-image"
            />
            <div className="image-overlay"></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SmarterAds;
